// src/components/Background.js
import React, { useMemo } from 'react'
import { styled, keyframes } from '@mui/system'

// Slow drifting gradient
const gradientAnimation = keyframes`
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`

// Gentle up/down drift for particles
const driftY = keyframes`
  0%   { transform: translateY(0); }
  50%  { transform: translateY(-25px); }
  100% { transform: translateY(0); }
`

// Container covers entire viewport
const BackgroundContainer = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: -1,
  background: 'linear-gradient(135deg, #090909, #1a1a1a)',
  backgroundSize: '400% 400%',
  animation: `${gradientAnimation} 90s ease infinite`,
})

// Subtle drifting particle
const Particle = styled('div')(({ size, top, left, delay, duration }) => ({
  position: 'absolute',
  width: size,
  height: size,
  backgroundColor: 'rgba(255,255,255,0.12)',
  borderRadius: '50%',
  top,
  left,
  filter: 'blur(1px)',
  animation: `${driftY} ${duration} ease-in-out ${delay} infinite`,
}))

export default function Background() {
  // Generate 35 random particles
  const particles = useMemo(() => {
    return Array.from({ length: 35 }, () => ({
      size: `${Math.random() * 4 + 3}px`,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 15}s`,
      duration: `${Math.random() * 25 + 15}s`,
    }))
  }, [])

  return (
    <BackgroundContainer>
      {particles.map((p, i) => (
        <Particle
          key={i}
          size={p.size}
          top={p.top}
          left={p.left}
          delay={p.delay}
          duration={p.duration}
        />
      ))}
    </BackgroundContainer>
  )
}